import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { CategoryBlockModule } from './categoryblock.module';
platformBrowserDynamic().bootstrapModule(CategoryBlockModule);
